import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import About from "../component/Header/About";
import Avatar from "../component/Header/Avatar";
import SocialLine from "../component/Header/SocialLine";
import TagLine from "../component/Header/TagLine";
import Layout from "../component/Layout/Layout";

export default function Header() {
  return (
    <div id="ABOUT">
      <Layout>
        <Grid container spacing={1}>
          <Grid item xs={2} lg={1}>
            <SocialLine />
          </Grid>
          <Grid item xs={10} lg={6}>
            <TagLine />
          </Grid>
          <Grid item xs={12} lg={5}>
            <Avatar />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={12} md={12} sx={{margin: '5px 0'}}>
            <Box>
              <Typography sx={{ color: '#d10855', textAlign: 'center' }} variant="h3">Experience & Educations</Typography>
            </Box>
          </Grid>
          <Grid  item xs={12} lg={12} md={12}>
            <About />
          </Grid>

        </Grid>
      </Layout>
    </div>);
}
